const theme = {
  palette: {
    primary: '#4a9eff',
    secondary: '#0066cc',
    background: '#0f0f0f',
    white: '#ffffff',
    black: '#0f0f0f',
    lightgray: '#333333',
    gray: '#666666',
    darkgray: '#999999',
    textPrimary: '#e0e0e0',
    textSecondary: '#b0b0b0',
    cardBackground: '#1a1a1a',
  },
  typography: {
    title: {
      fontFamily: '"Montserrat", "Noto Sans KR", sans-serif',
      fontSize: '5rem',
      fontWeight: 800,
    },
    subtitle: {
      fontFamily: '"Montserrat", "Noto Sans KR", sans-serif',
      fontSize: '3.5rem',
      fontWeight: 700,
      lineHeight: 1.1,
    },
    heading: {
      fontFamily: '"Montserrat", "Noto Sans KR", sans-serif',
      fontSize: '2rem',
      fontWeight: 700,
    },
    subheading: {
      fontFamily: '"Montserrat", "Noto Sans KR", sans-serif',
      fontSize: '1.5rem',
      fontWeight: 700,
    },
    label: {
      fontFamily: '"Montserrat", "Noto Sans KR", sans-serif',
      fontSize: '1.125rem',
      fontWeight: 700,
    },
    description: {
      fontFamily: '"Montserrat", "Noto Sans KR", sans-serif',
      fontSize: '1.125rem',
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body: {
      fontFamily: '"Montserrat", "Noto Sans KR", sans-serif',
      fontSize: '1rem',
      fontWeight: 400,
    },
    caption: {
      fontFamily: '"Montserrat", "Noto Sans KR", sans-serif',
      fontSize: '1rem',
      fontWeight: 400,
    },
    button: {
      fontFamily: '"Montserrat", "Noto Sans KR", sans-serif',
      fontSize: '1rem',
      fontWeight: 600,
    },
    textbutton: {
      fontFamily: '"Montserrat", "Noto Sans KR", sans-serif',
      fontWeight: 700,
      fontSize: '1.125rem',
      border: 0,
    },
  },
};

export default theme;
